import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const BhartiyaBhashaUtsavCelebration = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg17.jpg" }, 
    { img: "/assets/img/SOL/event/event1_mg18.jpg" }, 
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Bhartiya Bhasha Utsav Celebration" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
          <p>Date: December 11, 2024</p>
          <p>Venue: Mvn University</p>
          <p>Organized By: Language & Cultural Committee, Mvn University</p> 

          <ul>
              <li>	To celebrate the linguistic and cultural diversity of India.</li>
              <li>	To encourage students to appreciate and learn about different official languages spoken in India.</li>
              <li>	To highlight the importance of regional languages in shaping India's heritage and identity.</li>
              <li>	To foster a sense of unity and respect for all languages.</li>
              
          </ul>
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default BhartiyaBhashaUtsavCelebration;
